import { addEventListener, monitor } from '@datadog/browser-core';
export function listenActionEvents(_a) {
  var onClick = _a.onClick;
  var hasSelectionChanged = false;
  var selectionEmptyAtMouseDown;
  var hasInputChanged = false;
  var listeners = [addEventListener(window, "mousedown" /* MOUSE_DOWN */, function () {
    hasSelectionChanged = false;
    selectionEmptyAtMouseDown = isSelectionEmpty();
  }, {
    capture: true
  }), addEventListener(window, "selectionchange" /* SELECTION_CHANGE */, function () {
    if (!selectionEmptyAtMouseDown || !isSelectionEmpty()) {
      hasSelectionChanged = true;
    }
  }, {
    capture: true
  }), addEventListener(window, "click" /* CLICK */, function (clickEvent) {
    if (clickEvent.target instanceof Element) {
      // Use a scoped variable to make sure the value is not changed by other clicks
      var userActivity_1 = {
        selection: hasSelectionChanged,
        input: hasInputChanged
      };
      if (!hasInputChanged) {
        setTimeout(monitor(function () {
          userActivity_1.input = hasInputChanged;
        }));
      }
      onClick({
        event: clickEvent,
        getUserActivity: function () {
          return userActivity_1;
        }
      });
    }
  }, {
    capture: true
  }), addEventListener(window, "input" /* INPUT */, function () {
    hasInputChanged = true;
  }, {
    capture: true
  })];
  return {
    stop: function () {
      listeners.forEach(function (listener) {
        return listener.stop();
      });
    }
  };
}
function isSelectionEmpty() {
  var selection = window.getSelection();
  return !selection || selection.isCollapsed;
}
